import { render } from "./ViewContestants.vue?vue&type=template&id=58b8bb2a&scoped=true"
import script from "./ViewContestants.vue?vue&type=script&lang=js"
export * from "./ViewContestants.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=58b8bb2a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b8bb2a"]])

export default __exports__